module.exports = __webpack_public_path__ + "img/Surreality1.c1010773.png";